import { classicUtilities } from "./custom/utils/classic";
import { scrollToInput } from "./custom/form/scroll";
import {
    updateDealOfTheDayRootmenu, 
    headerFunctions
} from "./custom/utils/header";
import LazyLoad from "vanilla-lazyload";
import { jsEventLog } from "./custom/utils/log";

import $ from 'jquery';
jQuery.noConflict();

window.classicUtilities = classicUtilities;
window.scrollToInput = scrollToInput;
window.LazyLoad = LazyLoad;
window.jsEventLog = jsEventLog;

jQuery(function($) { 
    var myLazyLoad = new LazyLoad({
        elements_selector: ".lazy",
        threshold: 0
    });

    updateDealOfTheDayRootmenu();
    headerFunctions();
});